module.exports = __webpack_public_path__ + "img/logo-barriera-1.563dbac9.png";